<template>
  <section class="project-info">
    <!-- 项目相关支付 -->
    <h3 class="project-info-title">
      工程款支付情况
    </h3>
    <div class="project-pay-info">
      <span>合同价款：{{ payDetail.htjk }}</span>
      <span>补充价款：{{ payDetail.htbcjk }}</span>
      <span>已支付：{{ payDetail.htyzf }}</span>
      <span>支付期数：{{ payDetail.htzfqs }}</span>
      <!-- <span>最后支付时间：{{ payDetail.lastHtzftime }}</span> -->
    </div>
    <el-table :data="payDetail.gckItems" v-loading="loading" style="width: 100%">
      <el-table-column prop="payType" label="款项类别"></el-table-column>
      <el-table-column prop="bqshjk" label="本期审核(元)" align="center"></el-table-column>
      <el-table-column label="金额(元)" align="center">
        <template slot-scope="scope">
          <strong style="color:green;">
            {{ scope.row.price +" ("+scope.row.zfzshzj+"%)" }}
          </strong>
        </template>
      </el-table-column>
      <el-table-column label="付款发起人" width="180px" align="center">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="发起时间"></el-table-column>
      <el-table-column prop="passTime" label="审批通过时间"></el-table-column>
    </el-table>

    <!-- 父项目时，会有相关的其他支付 -->
    <section>
      <h3 class="project-info-title" style="margin-top:25px;">项目其他支付</h3>
      <el-table :data="payDetail.items" v-loading="loading" style="width: 100%">
        <el-table-column prop="payType" label="款项类别"></el-table-column>
        <el-table-column prop="bqshjk" label="本期审核(元)" align="center"></el-table-column>
        <el-table-column label="金额(元)" align="center">
          <template slot-scope="scope">
            <strong style="color:green;">
              {{ scope.row.price +" ("+scope.row.zfzshzj+"%)" }}
            </strong>
          </template>
        </el-table-column>
        <el-table-column label="付款发起人" width="180px" align="center">
          <template slot-scope="scope">
            <user-info :userData='scope.row.creator'></user-info>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="发起时间"></el-table-column>
        <el-table-column prop="passTime" label="审批通过时间"></el-table-column>
      </el-table>
    </section>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    props: ['projectId', 'isParentProject', 'isContract'],
    data() {
      return {
        payDetail: "",
        loading: false,
      }
    },
    mounted() {
      this.getProjectPay()
    },
    methods: {
      // 计算支付百分比
      getP(f, s) {
        if (s == 0 || !s) {
          return ''
        }
        return " (" + Math.round(f * 1000 / s) / 10 + "%)"
      },
      // 获取项目支付情况
      getProjectPay() {
        console.log(this.projectId)
        this.loading = true

        let _url = this.isContract ? '/pay/contract/pay/detail' : '/pay/project/pay/detail'
        let _form = this.isContract ? {
          contractId: this.projectId
        } : {
          projectId: this.projectId
        }
        ajax.get(_url, _form, (res) => {
          this.loading = false
          this.payDetail = res.vo
        })
      },
    },
    watch: {
      projectId() {
        this.getProjectPay()
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/project/infoPay.vue